import { render, staticRenderFns } from "./ReglementsList.vue?vue&type=template&id=36d1ea46&"
import script from "./ReglementsList.vue?vue&type=script&lang=ts&"
export * from "./ReglementsList.vue?vue&type=script&lang=ts&"
import style0 from "./ReglementsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports